import request from "../request"

// 分类搜索
const apiClassify = {
    // 获取品种分类
    getClassify: (pid, level) => request.post('/v1/nf/open/classify/search', { pid, level }),

    getClassifyTree: () => request.post('/v1/nf/open/classify/tree'),
}

const apiRecord = {
    // 大厅列表
    getList: (queryParams) => request.post('/v1/nf/open/post/search', { ...queryParams }),

    // 服务详情
    getDetails: (id) => request.get(`/v1/nf/open/post/${id}`),



}

// 需求大厅
const apiDemand = {
    // 大厅列表
    getList: (queryParams) => request.post('/v1/nf/open/post/require/search', { ...queryParams }),

    // 服务详情
    getDetails: (id) => request.get(`/v1/nf/open/post/require/${id}`)
}

// 新版大厅
const apiHall = {
    getList: (queryParams) => request.post('/v1/nf/open/new/show/search', { ...queryParams }),

    getDetails: (id) => request.get(`/v1/nf/open/new/show/${id}`),

    // 详情页的订单统计以及明细
    getOrder: (userId, type) => request.get(`/v1/nf/open/new/order/${userId}/${type}`),

    tempView: () => request.post(`/v1/nf/open/template/viewDoc`, { url: 'http://oos.yn-ag.cn/static/document/20231017/test.docx' }),
}

// 服务订单
const apiOrder = {
    getList: (queryParams) => request.post('/v1/nf/order/search', { ...queryParams }),

    getById: (id) => request.get(`/v1/nf/order/${id}`),

    add: (queryParams) => request.post('/v1/nf/order', { ...queryParams }),

    edit: (queryParams) => request.put('/v1/nf/order', { ...queryParams }),
}

const hall = {
    apiClassify,
    apiRecord,
    apiDemand,
    apiHall,
    apiOrder,
}

export default hall
